<div class="notification-tabs">
    <!-- 切换标签 -->
    <nz-tabset [nzSelectedIndex]="tabSelectedIndex" (nzSelectChange)="onTabChange($event)">
        <nz-tab [nzTitle]="('ALL_MESSAGE'| translate) +'('+unReadNumber?.totalCount+')' ">
            <notification-data (handleCloseNotification)="handleClose()" (handleGetList)="getMessageList('')" [notificationList]="notificationList"></notification-data>
        </nz-tab>
        <nz-tab [nzTitle]="('ACHIEVEMENT'| translate) +'('+getUnReadNumberByType(unReadNumber?.messageUnReadVOList,'Achievement')+')'">
          <ng-template nz-tab>
            <notification-data (handleCloseNotification)="handleClose()" (handleGetList)="getMessageList('Achievement')" [notificationList]="notificationList"></notification-data>
        </ng-template>
        </nz-tab>
        <nz-tab [nzTitle]="('ORDER'| translate) +'(' +getUnReadNumberByType(unReadNumber?.messageUnReadVOList,'Order')+')'">
            <ng-template nz-tab>
                <notification-data (handleCloseNotification)="handleClose()"  (handleGetList)="getMessageList('Order')" [notificationList]="notificationList"></notification-data>
            </ng-template>
        </nz-tab>
        <nz-tab [nzTitle]="('LOGISTIC'| translate) +'(' + getUnReadNumberByType(unReadNumber?.messageUnReadVOList,'Logistic')+')'">
          <ng-template nz-tab>
            <notification-data (handleCloseNotification)="handleClose()" (handleGetList)="getMessageList('Logistic')" [notificationList]="notificationList"></notification-data>
          </ng-template>
        </nz-tab>
    </nz-tabset>
</div>